<template>
  <div id="test">
    <!-- 测验 -->
    <div class="content">
      <div class="tests">
        <div v-if="showTestAgain">
          <van-button type="primary" block @click="doTestAgain"
            >再答一遍</van-button
          >
        </div>
        <div v-else>
          <div
            class="test"
            v-for="(v, i) in questions"
            :key="i"
            v-show="questionIndex == i"
          >
            <div class="progress">{{ i + 1 }} / {{ questions.length }}</div>

            <!-- <div class="questionType">
              <span v-if="v.type == 1">判断题</span>
              <span v-if="v.type == 2">单选题</span>
              <span v-if="v.type == 3">多选题</span>
            </div> -->
            <div class="question">
              【<span v-if="v.type == 1">判断题</span>
              <span v-if="v.type == 2">单选题</span>
              <span v-if="v.type == 3">多选题</span>】{{ v.question }}
            </div>
            <div class="options" v-if="v.type == 1 || v.type == 2">
              <div
                class="option"
                v-for="(vv, ii) in v.options"
                :key="ii"
                @click="choose(vv, ii)"
                :class="{
                  'action-option':
                    currentOptionIndex !== '' && currentOptionIndex == ii,
                }"
              >
                {{ vv }}
              </div>
            </div>
            <div class="options" v-if="v.type == 3">
              <div
                class="option"
                v-for="(vv, ii) in v.options"
                :key="ii"
                @click="chooseMul(vv, ii)"
                :class="{
                  'action-option':
                    currentMulOptionIndex !== [] &&
                    currentMulOptionIndex.includes(ii),
                }"
              >
                {{ vv }}
              </div>
            </div>
            <div class="btn">
              <van-button
                type="warning"
                size="small"
                @click="nextQuestion"
                :text="i < questions.length - 1 ? '下一题' : '提交'"
                :disabled="
                  currentOptionIndex === '' && currentMulOptionIndex.length == 0
                "
              ></van-button>
            </div>
          </div>
        </div>
        <van-overlay
          v-if="!isLottery"
          :show="showLottery"
          @click="showLottery = false"
          class="lottery"
        >
          <div class="wrapper" @click.stop>
            <LuckyWheel
              ref="myLucky"
              width="300px"
              height="300px"
              :prizes="prizes"
              :blocks="blocks"
              :buttons="buttons"
              @start="startCallback"
              @end="endCallback"
            />
          </div>
        </van-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueLuckyCanvas from "@lucky-canvas/vue";
import { getQuestions } from "@/api/fanzha";
import { hasDraw } from "@/api/fanzha";
import {
  getPrizeList,
  getFanzhaUserInfo,
  saveQueestionSubmission,
  draw,
} from "@/api/fanzha";

Vue.use(VueLuckyCanvas);

import { Button, Toast, Overlay, Dialog } from "vant";

export default {
  name: "Test",
  data() {
    return {
      // 大转盘相关start
      winPrizeId: 0,
      winPrizeName: "",
      wrongNums: 0,
      showLottery: false,
      blocks: [{ padding: "13px", background: "#FDE52D" }],
      prizes: [],
      buttons: [
        { radius: "50px", background: "#F87F02" },
        { radius: "45px", background: "#ffffff" },
        {
          radius: "40px",
          background: "#D43128",
          pointer: true,
          fonts: [{ text: "开始\n抽奖", top: "-20px" }],
        },
      ],
      lotterying: false,
      prizeRecord: {},
      afterReturnRand: {},
      isLottery: false,
      // 大转盘end
      // 答题start
      questions: [],
      questionIndex: 0,
      currentOptionIndex: "",
      currentMulOptionIndex: [],
      showTestAgain: false,
      // 答题end
      themeId: 1
    };
  },
  mounted() {
    getFanzhaUserInfo({themeId: this.themeId}).then((res) => {
      if (res.code == 1 && res.data == null) {
        this.$route.push({
          path: `/fzp/list`,
        });
      }
    });
    //获取题目
    this.getRandomQuestions();
    //判断今天是否抽过奖
    hasDraw({ type: 2,themeId: this.themeId }).then((res) => {
      if (res.code == 1) {
        this.isLottery = res.data.hasDraw;
      }
    });
    //获取奖品列表
    getPrizeList({themeId: this.themeId}).then((res) => {
      if (res.code == 1) {
        console.log(res.data);
        for (let i = 0; i <= res.data.length; i++) {
          let prize = {
            fonts: [
              {
                text: res.data[i].prizeName,
                top: "10%",
                fontSize: 13,
                lengthLimit: 60,
              },
            ],
          };
          if (res.data[i].id == 0) {
            prize.background = "#EBEBEB";
          } else if (i % 2 == 0) {
            prize.background = "#FFF4D6";
          } else {
            prize.background = "#FFFFFF";
          }
          this.prizes.push(prize);
        }
      }
    });
  },
  methods: {
    getRandomQuestions() {
      getQuestions().then((res) => {
        if (res.code == 1) {
          for (let i = 1; i <= res.data.length; i++) {
            this.questions.push({
              id: res.data[i - 1].id,
              question: res.data[i - 1].question,
              type: res.data[i - 1].category,
              options: res.data[i - 1].options,
              rightAnswer: res.data[i - 1].answer,
            });
          }
        }
      });
    },
    doTestAgain() {
      this.questionIndex = 0;
      this.currentOptionIndex = "";
      this.showTestAgain = false;
      this.questions = [];
      this.getRandomQuestions();
      this.wrongNums = 0;
    },
    choose(v, i) {
      this.currentOptionIndex = i;
    },
    chooseMul(v, i) {
      //判断是否在数组里
      var index = this.currentMulOptionIndex.indexOf(i);
      if (index > -1) {
        this.currentMulOptionIndex.splice(index, 1);
      } else {
        this.currentMulOptionIndex.push(i);
      }
    },
    nextQuestion() {
      if (this.questionIndex < this.questions.length - 1) {
        this.questionIndex++;
        //根据题目类型判断答案
        var qType = this.questions[this.questionIndex - 1].type;
        var qAnswer = this.questions[this.questionIndex - 1].rightAnswer;
        console.log(qType);
        console.log(qAnswer);
        console.log(this.currentOptionIndex);
        if (qType == 1 && qAnswer != this.currentOptionIndex + 1) {
          console.log("判断题错误");
          this.wrongNums++;
        }
        if (
          qType == 2 &&
          qAnswer != String.fromCharCode(this.currentOptionIndex + 65)
        ) {
          console.log("单选题错误");
          this.wrongNums++;
        }
        this.currentOptionIndex = "";
        this.currentMulOptionIndex = [];
      } else {
        //判断第三题多选题答案
        this.currentMulOptionIndex.sort();
        var mulStr = "";
        for (let i = 0; i < this.currentMulOptionIndex.length; i++) {
          mulStr =
            mulStr + String.fromCharCode(this.currentMulOptionIndex[i] + 65);
        }
        console.log;
        if (this.questions[this.questionIndex].rightAnswer != mulStr) {
          this.wrongNums++;
          console.log("多选题错误");
        }

        if (this.wrongNums == 0) {
          Dialog.alert({
            message: "恭喜！防诈先锋非您莫属！多向亲朋好友宣传防诈！",
          });
        }
        if (this.wrongNums == 1) {
          Dialog.alert({
            message:
              "您的防诈指数较高，可也别大意，骗局层出不穷，记得更新防骗知识！答对3题，就能抽奖啦！",
          });
        }
        if (this.wrongNums == 2) {
          Dialog.alert({
            message:
              "您的防诈指数较低，要提高防范意识，多学防诈知识，提高防骗识骗能力！",
          });
        }
        if (this.wrongNums == 3) {
          Dialog.alert({
            message:
              "这个……说实话，您是骗子最喜欢的对象！！赶紧来看视频学反诈，保护好你的钱袋子！",
          });
        }

        //上报答题记录
        saveQueestionSubmission({
          correct: 3 - this.wrongNums,
          wrong: this.wrongNums,
          themeId: this.themeId
        }).then((res) => {
          if (res.code != 1) {
            console.log("上报答题记录失败");
          }
        });

        // 判断今天是否已经抽奖过了
        if (this.isLottery) {
          Dialog.alert({ message: "您今天已经抽奖过了，请明天再来" });
          this.showTestAgain = true;
        } else if (this.wrongNums > 0) {
          this.showTestAgain = true;
        } else {
          //判断时间是否2月26号之前 26号之前
          var time = new Date().getTime();
          if (time <= 1645804800000) {
            this.showLottery = true;
          }else {
            this.showTestAgain = true;
          }
        }
      }
    },
    // 点击抽奖按钮会触发star回调
    startCallback() {
      if (this.lotterying) return false;
      this.lotterying = true;

      // 调用抽奖组件的play方法开始游戏
      this.$refs.myLucky.play();

      draw({ type: 2,themeId: this.themeId }).then((res) => {
        if (res.code == 1 && res.data.prize != null) {
          this.winPrizeId = res.data.prize.id;
          this.winPrizeName = res.data.prize.prizeName;
          this.$refs.myLucky.stop(res.data.prize.id - 1);
          this.lotterying = false;
        } else {
          this.$refs.myLucky.stop(this.prizes.length - 1);
          this.lotterying = false;
          //Dialog.alert({ message: res.msg });
        }
      });
      // TODO: ajax获得转盘结果
      /*
      getPrizeRand({
        theme_id: this.$route.params.id,
        record_id: this.prizeRecord.id
      }).then((res) => {
        // console.log(res)
        if (res.code == 1) {
          let result = res.data

          const index = result.index
          // 调用stop停止旋转并传递中奖索引
          this.$refs.myLucky.stop(index)

          this.afterReturnRand = res
        } else {
          Toast.fail(res.msg)
        }
        this.lotterying = false
      })
      */
    },
    // 抽奖结束会触发end回调
    endCallback(prize) {
      console.log(prize);
      var dMsg = "明天再来";
      if (this.winPrizeName != "") {
        dMsg = "恭喜你获得" + this.winPrizeName + " x 1";
      }
      Dialog.alert({ message: dMsg }).then(() => {
        this.showLottery = false;
        this.isLottery = true;
        this.showTestAgain = true;
      });
      // console.log('end', prize)
      /*
      this.prizeRecord.status = '1'
      let result = this.afterReturnRand.data
      if (result.is_win) {
        // 中奖了，信息登记
        Toast.success(this.afterReturnRand.msg)
        this.showLottery = false
        this.myPrize = result.title
        this.$nextTick(() => {
          this.showWinnerForm = true
        })
      } else {
        this.showLottery = false
        Toast({ message: this.afterReturnRand.msg, duration: 4000 })
      }
      */
    },
  },
};
</script>

<style lang="less" scoped>
.tests {
  background-color: #ffe9bb;
  border-radius: 10px;
  color: #000;
  padding: 10px;
  .test {
    .progress {
      text-align: center;
      font-weight: bold;
    }
    .question {
      font-size: 14px;
      text-indent: 2em;
    }
    .options {
      .option {
        border: 1px solid #8e8e8e;
        border-radius: 5px;
        font-size: 14px;
        margin: 10px 0;
        padding: 5px;
      }
      .action-option {
        background-color: rgb(212, 0, 4);
        color: #fff;
      }
    }
    .btn {
      text-align: right;
    }
  }
}

.lottery {
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
